import { Injectable } from '@angular/core';
import { ValidatorFn, AbstractControl } from '@angular/forms';
import { User } from '@core/modules/user/models';
import { CaptivePortalService } from '@core/modules/user/services/captive-portal.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'any'
})
export class MyInterestsFormService {
  constructor(private captivePortalService: CaptivePortalService) {}

  interestsValidator(): ValidatorFn {
    return (control: AbstractControl) =>
      Object.values(control.value as boolean[]).reduce(
        (selected, isSelected) => (isSelected ? ++selected : selected),
        0
      ) >= 3
        ? null
        : { minInterests: 3 };
  }

  getDevicesInterests(
    devicesIds: number[]
  ): Observable<{ name: string; id: number }[]> {
    return this.captivePortalService.getInterestsDevices(devicesIds);
  }

  getDevicesIds(user: User | undefined): number[] {
    return user?.devices
      ?.map((device) => device.id)
      .filter((deviceId) => !!deviceId) as number[];
  }

  getSelectedInterestsIds(values: { [id: string]: boolean }): number[] {
    return Object.keys(values).reduce(
      (interests, id) => (values[id] ? [...interests, Number(id)] : interests),
      [] as number[]
    );
  }
}
